<template>
  <div class="menu-container">
    <div class="menu-title">关于协会</div>
    <ul>
      <li>协会概况</li>
      <li>协会章程</li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "leftMenu",
  props: {
  },
  data() {
    return {};
  },
  created() {},
  computed: {},
  methods: {},
  watch: {},
};
</script>
<style scoped lang="scss">
.menu-container {
  width: 90%;
  // border: 1px solid #ccc;
  margin: 16px auto;
  .menu-title {
    height: 70px;
    width: 100%;
    background-image: url("../assets/css/img/menu-1.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    color: #fff;
    font-size: 22px;
    padding-left: 14%;
    line-height: 70px;
  }
  ul {
    width: 100%;
    li {
      height: 60px;
      line-height: 60px;
      background: #f5f5f5;
      color: #333333;
      font-size: 14px;
      text-align: center;
      margin-top: 2px;
      cursor: pointer;
    }
  }
}
</style>
